import { startCase } from 'lodash-es'
import { TFunction } from 'react-i18next'
import { Transaction } from 'types/transaction'

interface GetTitleTransactionProps {
  transaction: Transaction
  t: TFunction<'translation', undefined>
}

export const getTransactionTitle = ({ transaction, t }: GetTitleTransactionProps) => {
  if (!transaction) return

  let type: string = transaction?.type
  if (transaction?.context?.subType === 'trade' && transaction?.type !== 'processingFee') {
    type = transaction.context.subType
  }

  switch (type) {
    case 'trade':
      return t?.('convertAction', {
        action: transaction?.type === 'payOut' ? 'Out' : 'In',
        currencyNameFrom: transaction?.context?.fromCurrencyCode,
        currencyNameTo: transaction?.context?.toCurrencyCode,
      })
    case 'paymentIn':
      return startCase('paymentIn')
    case 'paymentOut':
      return startCase('paymentOut')
    case 'paymentRefund':
      return startCase('paymentRefund')
    case 'overPayment':
      return startCase('overPayment')
    case 'underPayment':
      return startCase('underPayment')
    case 'reversal':
      return startCase('reversal')
    case 'processingFee':
      return startCase('processingFee')
    case 'networkFee':
      return startCase('networkFee')
    case 'bvnkNetworkTransfer':
      return startCase('bvnkNetworkTransfer').replace('Bvnk', 'BVNK')
    case 'fdusdTradeInSettlement':
      return startCase('fdusdTradeInSettlement').replace('Fdusd', 'FDUSD')
    default:
      return startCase(type)
  }
}
